define('view/controller/booking/datetime/flexible/TimeFlexibleView',['require','view/controller/booking/datetime/TimeDefaultView','view/controller/booking/datetime/flexible/TimeFlexibleHourView','Config'],function (require) {

    var TimeDefaultView = require('view/controller/booking/datetime/TimeDefaultView');
    var TimeFlexibleHourView = require('view/controller/booking/datetime/flexible/TimeFlexibleHourView');
    var Config = require('Config');

    /**
     * Flexible timeline view (container)
     *
     * @class TimeFlexibleView
     */
    return TimeDefaultView.extend({

        template: '#time_flexible_view',
        childView: TimeFlexibleHourView,
        childViewContainer: '#sb_time_flexible_container',
        childEvents: {
            'hover:time': 'onTimeHover',
            'select:time': 'onTimeSelected'
        },
        _timeCollection: null,
        _calendarCollection: null,
        _cisEmptyDay: false,
        _cisAvailableDay: true,

        initialize: function () {
            this._timeCollection = this.getOption('timeCollection');
            this._calendarCollection = this.getOption('calendarCollection');

            if (this._timeCollection.length) {
                this._updateCollection();
            }

            this.listenTo(this._timeCollection, 'sync', _.bind(function () {
                this._updateCollection();
                this.render();
            }, this));

            this.listenTo(this._calendarCollection, 'sync', _.bind(function () {
                this._updateCollection();
                this.render();
            }, this));

            TimeDefaultView.prototype.initialize.apply(this);
        },

        _updateCollection: function () {
            this.collection = this._timeCollection.getCollectionGroupedByHour();

            this._cisEmptyDay = this._isEmptyDay();
            var waitingListHelperModel = this.getOption('waitingListHelperModel');
            if(waitingListHelperModel) {
                this._cisAvailableDay = waitingListHelperModel.isTodayOrFutureDates() && waitingListHelperModel.isWorkDateInterval();
            }
        },

        onTimeHover: function (event, model) {
            this._timeCollection.each(function (m) {
                if (model.get('id') === m.get('id')) {
                    return;
                }
                var state = m.get('state') || '';
                if (_.includes(state.split(' '), 'hovered')) {
                    m.set('state', '');
                }
            });

            var totalRequiredSlots = this._getSlotsToBook();
            var actualServiceSlots = this._getActualServiceSlots();
            _.each(this._getAvailableSlotModels(model), function (m, index) {
                if (index < actualServiceSlots) {
                    m.set('state', 'hovered');
                } else {
                    m.set('state', 'hovered buffertime');
                }
            });
        },

        onTimeSelected: function (event, model) {
            this.onTimeHover(event, model);

            if(model.get('wl')){ //is book to waiting list
                this.triggerMethod('timeChanged', null, model.get('date'), 1);
                return true;
            }

            var slotsCount = this._getSlotsToBook();
            var actualServiceSlots = this._getActualServiceSlots();
            if (Config.getInstance().getOption('allow_buffertime_extend') == "1") {
                slotsCount = actualServiceSlots;
            }
            var availableSlots = this._getAvailableSlotModels(model);
            if (availableSlots.length < slotsCount) {
                if (!availableSlots.length) {
                    this.showErrorMessage(Locale.getNonEscape('selected_slots_are_not_available'));

                    return false;
                }
                var lastSlotModel = _.last(availableSlots);
                if (lastSlotModel !== this._timeCollection.last() && !Config.getInstance().isAllowedBookOverBreaktime()) {
                    this.showErrorMessage(Locale.getNonEscape('selected_slots_are_not_available'));

                    return false;
                } else if (!Config.getInstance().isAllowedBookOverDay()) {
                    this.showErrorMessage(Locale.getNonEscape('selected_slots_are_not_available'));

                    return false;
                }
            }

            this.triggerMethod('timeChanged', model.get('time'), model.get('date'));
        },

        _getFirstFreeModel: function(date){
            if(!this._timeCollection.length){
                return null;
            }
            for (var i = 0; i < this._timeCollection.length; i++) {
                var hModel = this._timeCollection.at(i);
                if (hModel && hModel.get('date') === date && hModel.get('type') === 'free'){
                    return hModel;
                    break;
                }
            }
            return null;
        },

        _getAvailableSlotModels: function (model) {
            var result = [];
            var slots = this._getSlotsToBook();
            var start = this._timeCollection.findIndex(model);

            for (var i = start; i < this._timeCollection.length; i++) {
                var hModel = this._timeCollection.at(i);

                // means that we do not allow to extend booking over the day
                if (hModel.get('date') !== model.get('date') && !Config.getInstance().isAllowedBookOverDay()) {
                    break;
                }
                // allowed to book if the slot is free
                if (hModel.get('type') === 'free') {
                    result.push(hModel);
                    slots--;
                // do not allow if slot is reserved
                } else if (hModel.get('type') === 'reserved') {
                    return [];
                    //break;
                // do not allow to extend booking over the breaktime
                } else if (!Config.getInstance().isAllowedBookOverBreaktime()) {
                    break;
                }
                // found all slots to book
                if (slots === 0) {
                    break;
                }
            }

            return result;
        },

        _getSlotsToBook: function () {
            var slots = 1;
            
            if (this.getOption('bookingModel').get('service')) {
                var products = this.getOption('bookingModel').getProductsAddonsList();
                products = products ? products.map(function (product) { return product.duration; }) : [];
                var productsDuration = _.reduce(products, function (a, b) { return +a + +b; }, 0);
                
                var duration = ~~this.getOption('bookingModel').get('service').duration + ~~this.getOption('bookingModel').get('service').buffertime_after + productsDuration;
                slots = duration / Config.getInstance().getTimeFrame();
            }

            return slots;
        },
        
        _getActualServiceSlots: function () {
            var slots = 1;
            
            if (this.getOption('bookingModel').get('service')) {
                var products = this.getOption('bookingModel').getProductsAddonsList();
                products = products ? products.map(function (product) { return product.duration; }) : [];
                var productsDuration = _.reduce(products, function (a, b) { return +a + +b; }, 0);
                
                var duration = ~~this.getOption('bookingModel').get('service').duration + productsDuration;
                slots = duration / Config.getInstance().getTimeFrame();
            }

            return slots;
        },

        _isEmptyDay : function (){
            var _this = this;
            var isEmptyDay = true;

            var waitingListHelperModel = this.getOption('waitingListHelperModel');

            if(waitingListHelperModel){
                var date = waitingListHelperModel.getCurrentDate();
                if(!date){
                    return true;
                }
                var fmodel = this._getFirstFreeModel(date);
            } else {
                fmodel = this._timeCollection.at(0);
            }

            if(!fmodel){
                return true;
            }
            var avSlots = _this._getAvailableSlotModels(fmodel);

            if(avSlots && avSlots.length){
                isEmptyDay = false;
            }
            return isEmptyDay;
        },

        serializeData: function () {
            var result = TimeDefaultView.prototype.serializeData.apply(this);
            result.is_empty = !this.collection || !this.collection.length || !this.getOption('clientTimeZone').isReady();
            result.is_available_date = this._cisAvailableDay;
            
            if (Config.getInstance().getPluginStatus('waiting_list')) {
                result.is_empty_day = this._cisEmptyDay;
                result.is_empty = this._cisEmptyDay;
            }
            return result;
        }

    });

});
